import { ICommonAction } from "../interfaces/common-action.interface";

export const COMMON_ACTIONS: ICommonAction[] = [
    {
        action: "Manually drove robot"
    },
    {
        action: "Replaced/restarted battery",
        multiWheel: true
    },
    {
        action: "Replaced robot",
        multiWheel: true
    },
    {
        action: "Restarted using handheld controller"
    },
    {
        action: "Gyro calibration"
    },
    {
        action: "OOB calibration"
    },
    {
        action: "Relocalized robot"
    },
    {
        action: "Replaced mecanum wheel",
        multiWheel: true
    },
    {
        action: "Levelling"
    },
]
